export default "__VITE_ASSET__B7kYMr2H__"